import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserDataService } from '../../services/user-data.service';
import { ApiServiceService } from '../../services/api-service.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit, OnDestroy {
  categoriesProduct: any[] = [];
  private categorySubscription: Subscription | undefined;

  // Track hovered categories for 4 levels
  hoveredCategory: number | null = null;
  hoveredSubCategory: number | null = null;
  hoveredSubSubCategory: number | null = null;

  // Flag to toggle showing all categories
  showAllCategories = false;

  // Flag to toggle popup visibility
  showMorePopup = false;
  morePopupStyle: { [key: string]: string } = {};
  categoryPopupStyle: { [key: string]: string } = {};

  constructor(private api: ApiServiceService, private Router: Router) {}

  ngOnInit() {
    this.getAllCategories();
  }

  ngOnDestroy() {
    this.categorySubscription?.unsubscribe();
  }

  // Toggle showing all categories
  toggleShowAllCategories(): void {
    this.showAllCategories = !this.showAllCategories;
  }

  openMorePopup(event: MouseEvent): void {
    this.showMorePopup = true;

    const trigger = event.currentTarget as HTMLElement;
    const bounds = trigger.getBoundingClientRect();
    const popupWidth = Math.min(192, window.innerWidth - 16);
    const left = Math.max(8, Math.min(bounds.left, window.innerWidth - popupWidth - 8));

    this.morePopupStyle = {
      position: 'fixed',
      left: `${left}px`,
      right: 'auto',
      top: `${bounds.bottom}px`,
      width: `${popupWidth}px`,
      ...(window.innerWidth <= 767 ? { maxHeight: '70vh', overflowY: 'auto' } : {})
    };
  }

  openCategoryMenu(event: MouseEvent, index: number): void {
    this.setHoveredCategory(index);

    const trigger = event.currentTarget as HTMLElement;
    const bounds = trigger.getBoundingClientRect();
    const popupWidth = Math.min(192, window.innerWidth - 16);
    const left = Math.max(8, Math.min(bounds.left, window.innerWidth - popupWidth - 8));

    this.categoryPopupStyle = {
      position: 'fixed',
      left: `${left}px`,
      right: 'auto',
      top: `${bounds.bottom}px`,
      width: `${popupWidth}px`,
      ...(window.innerWidth <= 767 ? { maxHeight: '70vh', overflowY: 'auto' } : {})
    };
  }
         
  getAllCategories() {
    this.categorySubscription = this.api.getAllCategories().subscribe({
      next: (data: any) => {
        this.categoriesProduct = data.categories; 
      },
      error: (err) => console.error('Error fetching categories:', err),
    });
  }

  setHoveredCategory(index: number) {
    this.hoveredCategory = index;
    this.hoveredSubCategory = null;
    this.hoveredSubSubCategory = null;
  }

  clearHoveredCategory() {
    this.hoveredCategory = null;
    this.hoveredSubCategory = null;
    this.hoveredSubSubCategory = null;
  }

  setHoveredSubCategory(index: number) {
    this.hoveredSubCategory = index;
    this.hoveredSubSubCategory = null;
  }

  clearHoveredSubCategory() {
    this.hoveredSubCategory = null;
    this.hoveredSubSubCategory = null;
  }

  setHoveredSubSubCategory(index: number) {
    this.hoveredSubSubCategory = index;
  }

  clearHoveredSubSubCategory() {
    this.hoveredSubSubCategory = null;
  }

  goToCategory(catId: any){
    this.Router.navigate(["product-list", catId])
  }

}
